import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"
import React, { useEffect, useState } from "react"

import ExpandMoreIcon from "@mui/icons-material/ExpandMoreOutlined"
import "./index.css"

const CustomAccordion = (props) => {
  const [expanded, setExpanded] = useState(false)

  const { title, children, expand = false, id = "", onToggleExpand } = props

  useEffect(() => {
    if (onToggleExpand && expanded !== expand) {
      onToggleExpand(id, expanded)
    }
  }, [expanded])

  useEffect(() => {
    setExpanded(expand)
  }, [expand])

  return (
    <Accordion
      disableGutters
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      elevation={0}
      id={id}
      sx={{
        boxShadow: "none", // Removes the default shadow to make it cleaner
        "&.MuiAccordionSummary-root": {
          position: "relative", // Ensures pseudo-element is positioned correctly
          "&::before": {
            content: '""',
            height: "0px",
          },
        },
        width: "100%",
        height: "fit-content",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        disableGutters
        sx={{
          height: "60px", // Fixed height for the header to avoid stretching
          minHeight: "60px", // Ensures the header height remains constant even if content inside changes
          display: "flex", // Ensures the content inside the header stays aligned properly
          alignItems: "center", // Centers the text vertically
        }}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          padding: "16px", // Default padding
          overflow: "hidden", // Prevents overflow when collapsed
          transition: "max-height 0.3s ease", // Smooth transition for the body height change
          maxHeight: expanded ? "500px" : "0", // Dynamically adjust the max height
          display: "flex",
          flexDirection: "column", // Ensures the form fields are stacked vertically
          gap: "20px",
          borderTop: "3px solid #dfdfdd",
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default CustomAccordion
